import axiosPrivate from "./axiosPrivate";

const getProcesoRequerimientos = (periodo, estado = "") => {
  return axiosPrivate.get("proceso-requerimientos", { params: { periodo, estado } }).then(res => res.data);
};

const guardarRequerimiento = (data) => {
  return axiosPrivate.post("proceso-requerimientos", data).then(res => res.data);
};

const aprobarJefe = (id, observacion_jefe = "") => {
  return axiosPrivate.post(`proceso-requerimientos/${id}/aprobar-jefe`, { observacion_jefe }).then(res => res.data);
};

const observarJefe = (id, observacion_jefe) => {
  return axiosPrivate.post(`proceso-requerimientos/${id}/observar-jefe`, { observacion_jefe }).then(res => res.data);
};

const atenderLogistica = (id, data) => {
  return axiosPrivate.post(`proceso-requerimientos/${id}/atender-logistica`, data).then(res => res.data);
};

const aprobarSubgerencia = (id, observacion_subgerencia = "") => {
  return axiosPrivate.post(`proceso-requerimientos/${id}/aprobar-subgerencia`, { observacion_subgerencia }).then(res => res.data);
};

const observarSubgerencia = (id, observacion_subgerencia) => {
  return axiosPrivate.post(`proceso-requerimientos/${id}/observar-subgerencia`, { observacion_subgerencia }).then(res => res.data);
};

const registrarPago = (id, fecha_pago, archivo_pago) => {
  const formData = new FormData();
  formData.append("fecha_pago", fecha_pago);
  formData.append("archivo_pago", archivo_pago);

  return axiosPrivate.post(`proceso-requerimientos/${id}/pagar`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  }).then(res => res.data);
};

const anularRequerimiento = (id) => {
  return axiosPrivate.delete(`proceso-requerimientos/${id}`).then(res => res.data);
};

const ProcesoRequerimientosService = {
  getProcesoRequerimientos,
  guardarRequerimiento,
  aprobarJefe,
  observarJefe,
  atenderLogistica,
  aprobarSubgerencia,
  observarSubgerencia,
  registrarPago,
  anularRequerimiento,
};

export default ProcesoRequerimientosService;
